// Make taps on search suggestions navigate, even if the theme blocks default
(function () {
  function navigateIfLink(target) {
    const link = target.closest(
      'a.search-flydown--product, .search-flydown__group-list a, .search-flydown__query-link-item a'
    );
    if (!link) return false;
    const href = link.getAttribute('href');
    if (!href || href === '#' || href.startsWith('javascript:')) return false;

    // Stop the search form from intercepting the event
    try {
      event?.preventDefault?.();
      event?.stopPropagation?.();
      event?.stopImmediatePropagation?.();
    } catch (_) {}

    window.location.assign(link.href);
    return true;
  }

  // Catch the common event types that themes hook
  ['pointerup', 'touchstart', 'click'].forEach((type) => {
    document.addEventListener(
      type,
      (e) => {
        if (navigateIfLink(e.target)) {
          // On touch devices, prevent the theme from re-submitting the form
          e.preventDefault?.();
          e.stopPropagation?.();
          e.stopImmediatePropagation?.();
        }
      },
      { capture: true, passive: false }
    );
  });
})();
